/**************************************************
 * Nombre:       Home_Testimonios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import fondo from '../../../Recursos/fondo_testimonios.svg'
import fondo_cell from '../../../Recursos/fondo_testi_cell.svg'
import punto from "../../../Recursos/punto.svg";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import Tarjeta_Testimonios from "../../Tarjetas/Tarjeta_Testimonios";
import cafe from "../../../Recursos/cafe_color.svg";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../../App";
import {useDialogo} from "../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Solicitud from "../../Dialogos/Dialogo_Solicitud";

const Home_Testimonios = () => {
    const {sCell, masSM} = useResponsive()
    const cData = useContext(contexApp)
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Solicitud,
        titulo: 'Formulario de solicitud de muestrario'
    })
    const [testimonios, setTestimonios] = useState([])

    useEffect(() => {

        if (cData.testimonios.length > 0) {
            setTestimonios(cData.testimonios)
        }


    }, [cData])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: `url(${sCell ? fondo_cell : fondo})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center left',
                color: '#fff',
                pb: sCell ? 6 : 20
            }}
        >

            <Dialogo/>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: sCell ? 10 : 18}}>
                    <Typography>
                                <span>
                                   <img src={punto} width={12} height={12} style={{paddingRight: 8}}/>
                                </span>
                        Testimonios
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                    <Typography sx={{fontSize: sCell ? 28 : 32, fontWeight: 700, textAlign: 'center'}}>Lo que
                        dicen de nosotros</Typography>
                </Grid>


                {testimonios.length > 0 &&
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 10}}>
                        <Splide
                            aria-label="My Favorite Images" style={{width: '100%'}}
                            options={{
                                autoplay: true,
                                speed: 1500,
                                rewind: true,
                                perPage: 1,
                                arrows: true,
                                pagination: false,
                                width: '100%',
                                drag: 'false',
                                interval: 5000,
                                noDrag: true,
                                perMove: 1,
                                gap: 20,
                                padding: !masSM ? 40 : 400

                            }}
                        >

                            {testimonios.map((item, index) => {
                                return (
                                    <SplideSlide key={`qe${index}`}>
                                        <Tarjeta_Testimonios item={item}/>
                                    </SplideSlide>
                                )
                            })}


                        </Splide>
                    </Grid>
                }


            </Grid>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, mt: sCell ? 12 : 24}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontSize: 32, fontWeight: 800, lineHeight: 1.2}}>Café de Nariño,
                                        Colombia</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 4}}>
                                    <Typography sx={{fontSize: 28, fontWeight: 600, lineHeight: 1.2}}>Exportamos al
                                        mundo la esencia
                                        del mejor
                                        café</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 6}}>
                                    <Typography sx={{fontSize: 18, fontWeight: 400}}>
                                        Desde las montañas del sur de Colombia llevamos al mundo un café reconocido
                                        por su aroma
                                        intenso, acidez brillante y sabor excepcional.
                                        <br/>
                                        <br/>
                                        En Orígenes Coffee cultivamos, seleccionamos y exportamos con trazabilidad
                                        total,
                                        compartiendo con cada taza el orgullo del café nariñense.
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 8}}>
                                    <Button
                                        onClick={() => abrir()}
                                        color={'secondary'}
                                        sx={{py: 2}}
                                    >
                                        <Grid
                                            container
                                            justifyContent={'flex-start'}
                                            alignItems={'flex-start'}
                                            size={{xs: 12, sm: 12, md: 12}}>


                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: 'center'}}>
                                                <IconButton>
                                                    <img src={cafe} width={42} height={'auto'}/>
                                                </IconButton>
                                            </Grid>

                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: 'center'}}>
                                                <Typography>
                                                    Solicita tu muestrario de café
                                                </Typography>
                                            </Grid>

                                        </Grid>
                                    </Button>
                                </Grid>


                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 9}} sx={{justifyContent: 'flex-start', mt: 8}}>
                            <Typography sx={{fontSize: 18, fontWeight: 400}}>
                                Descubre la calidad y el sabor único del café especial. Completa el formulario y
                                nuestro equipo
                                evaluará tu solicitud para enviarte un muestrario seleccionado especialmente
                                para ti, garantizando
                                trazabilidad, frescura y excelencia en cada grano.
                            </Typography>
                        </Grid>

                    </Grid>

                </Grid>


            </Grid>

        </Grid>
    )

}
export default Home_Testimonios

const items = [1, 2, 3, 4, 5, 6, 7, 8]